/* eslint-disable */
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import classes from './Waveform.module.css'
import * as d3 from 'd3'
import _ from 'lodash'
import toast from 'react-hot-toast'
// XXX import MainsFilter from '../MainsFilter'
import * as Lib from "../../../constants/annotator"

const Waveform = (props) => {
    const {
      height,
      mainsFreq,
      samples,
      selectedFilter,
      mvSwing,
      frequency,
      scale = 1,
      waveformStrokeColor = "#bb2739",
    } = props

    useEffect(() => {
      if (frequency == null) {
        toast.error("Waveform: sampling rate missing — cannot render ECG correctly.", { id: 'waveform-frequency-missing' })
      }
    }, [frequency])

    if (frequency == null) return null

    const stripTimeSec = samples.length / frequency
    const stripWidthPx = stripTimeSec * Lib.PX_PER_SECOND * scale

    let first = true
    const freqRatio = mainsFreq === 60 ? 5 : 6
    const prevVals = new Array(freqRatio)
    let index = 0

    const MainsFilter = sample => {
      if (first) {
        let i = 0
        while (i < freqRatio) {
          prevVals[i] = sample
          i += 1
        }
        first = false
        return sample
      } else {
        prevVals[index] = sample
        const sum = prevVals.reduce((s, num) => s + num, 0)
        index += 1
        if (index === freqRatio) {
          index = 0
        }
        return sum / freqRatio
      }
    }

    const xScale = () => d3.scaleLinear()
      .domain([ 0, samples.length ])
      .range([ 0, stripWidthPx ])

    const yScale = () => {
      // TODO this domain needs to be set from properties of the recording
      return d3.scaleLinear()
        .domain([ (mvSwing * -1), mvSwing ])
        .range([ height, 0 ])
    }

    const renderWaveform = (samplesForWaveform, h) => {
      const returnX = (d, i) => xScale()(i)
      const returnY = d => {
        let newD = d
        if (selectedFilter === 'original') {
          newD = MainsFilter(newD)
        }
        return yScale()(newD)
      }
      const line = d3.line()
        .x(returnX)
        .y(returnY)
      return line(samplesForWaveform)
    }

    return (
      <g className={classes.tracing}>
        <path style={{"stroke": waveformStrokeColor}} d={renderWaveform(props.samples, props.height)} />
      </g>
    )
}

export default Waveform
